export const JobsListFields = ['id', 'title', 'numberOfApplications', 'startDate'];
